import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCircularLoading = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={36} height={37} fill='none' {...props}>
    <path
      fill='#143366'
      d='M18 2a16.5 16.5 0 1 0 0 33 16.5 16.5 0 0 0 0-33m0 28.5a12 12 0 1 1 0-24 12 12 0 0 1 0 24'
      opacity={0.25}
    />
    <path
      fill='#143366'
      d='M15.21 2.24a16.5 16.5 0 0 0-13.5 13.38 2.385 2.385 0 0 0 1.98 2.88 2.28 2.28 0 0 0 2.475-1.95 12 12 0 0 1 9.99-9.915A2.13 2.13 0 0 0 18 4.535a2.354 2.354 0 0 0-2.79-2.295'
    />
  </svg>
);
export default SvgCircularLoading;
